import React, { useEffect, useState, useRef } from 'react'
import { withRouter } from 'react-router-dom'
import { injectIntl } from 'react-intl';
import Helmet from 'react-helmet';

import AdSense from 'react-adsense';
// import loadGAds from '../common/loadGAds';

import Header from '../common/template/header';
import Footer from '../common/template/footer';
import Routes from './routes';
import { getLanguageFromPath, LOCALE_MAP } from '../_i18n/urlHelper';
import { getCachedCountry, detectCountry, isRussianCountry } from '../common/geoTargeting';
import RussianSideRails from '../common/RussianSideRails';
import RussianSocialBar from '../common/RussianSocialBar';
// import ShowBanner from '../common/showBanner';

const RussianAdBanner = () => {
    const bannerRef = useRef(null);

    useEffect(() => {
        const wrapper = bannerRef.current;
        if (!wrapper) return;

        // Prevent duplicate script injection
        if (wrapper.querySelector('script[src*="0c9b8ca2492ae39332e4a1b5a9f52d39"]')) {
            return;
        }

        const script = document.createElement('script');
        script.src = 'https://pl25968446.profitableratecpmnetwork.com/0c9b8ca2492ae39332e4a1b5a9f52d39/invoke.js';
        script.async = true;
        script.setAttribute('async', 'async');
        script.setAttribute('data-cfasync', 'false');

        const container = wrapper.querySelector('#container-0c9b8ca2492ae39332e4a1b5a9f52d39');
        if (container) {
            wrapper.insertBefore(script, container);
        } else {
            wrapper.appendChild(script);
        }
    }, []);

    return (
        <div
            ref={bannerRef}
            className="ru-ad-wrapper"
            style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100px'
            }}
        >
            <div id="container-0c9b8ca2492ae39332e4a1b5a9f52d39"></div>
        </div>
    );
};

const App = (props) => {
    const [adsReady, setAdsReady] = useState(false);
    const [country, setCountry] = useState(getCachedCountry);
    const isRussia = isRussianCountry(country);

    // Detect visitor country (Geo-Targeting)
    useEffect(() => {
        if (!country) {
            detectCountry().then((detected) => {
                setCountry(detected || 'UNKNOWN');
            });
        }
    }, [country]);

    // Detecta o idioma atual da URL ou contexto intl para navegação interna
    const path = (props.location && props.location.pathname) || (typeof window !== 'undefined' ? window.location.pathname : '');
    const pathLang = getLanguageFromPath(path).lang;
    const intlLang = props.intl && props.intl.locale ? props.intl.locale.split('-')[0].toLowerCase() : null;
    const currentLang = props.currentLang || (pathLang !== 'en' ? pathLang : (intlLang || 'en'));

    const adWrapperRef = useRef(null);
    const [adVisible, setAdVisible] = useState(false);

    const attachScript = React.useCallback((src, attrs = {}) => {
        return new Promise((resolve) => {
            const existing = document.querySelector(`script[src="${src}"]`);
            if (existing) return resolve(existing);

            const script = document.createElement('script');
            script.src = src;
            script.async = true;
            Object.keys(attrs).forEach(key => {
                script.setAttribute(key, attrs[key]);
                try {
                    script[key] = attrs[key];
                } catch (e) {}
            });

            script.onload = () => resolve(script);
            script.onerror = () => resolve(null);

            document.head.appendChild(script);
        });
    }, []);

    const loadGAScript = React.useCallback(async () => {
        if (window.__gaLoaded__) return;
        window.__gaLoaded__ = true;

        await attachScript('https://www.googletagmanager.com/gtag/js?id=G-0GTPYDNSSG');
        if (!isRussia) {
            await attachScript('https://fundingchoicesmessages.google.com/i/pub-2605486701851317?ers=1');
        }

        window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', 'G-0GTPYDNSSG');
    }, [attachScript, isRussia]);

    const loadAdScripts = React.useCallback(async () => {
        // Do not load AdSense script for Russia
        if (isRussia) return;

        if (window.__adScriptsLoaded__) return;
        window.__adScriptsLoaded__ = true;

        await attachScript('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2605486701851317', { crossOrigin: 'anonymous' });
        window.adsbygoogle = window.adsbygoogle || [];
        setAdsReady(true);
    }, [attachScript, isRussia]);


    useEffect(() => {
        // Load GA immediately on mount
        setTimeout(() => {
            loadGAScript();
        }, 1000);
    }, [loadGAScript]);

    // Injeção de script Popunder exclusivo para acessos da Rússia
    useEffect(() => {
        if (!isRussia) return;
        if (typeof document === 'undefined') return;

        const popunderSrc = 'https://pl25981067.profitableratecpmnetwork.com/d7/52/71/d75271cf73aed7f2bc4ead5e209a7f5f.js';
        if (document.querySelector('script[src*="d75271cf73aed7f2bc4ead5e209a7f5f"]')) {
            return;
        }

        const script = document.createElement('script');
        script.src = popunderSrc;
        script.async = true;
        (document.body || document.head).appendChild(script);
    }, [isRussia]);

    useEffect(() => {
        // Wait until country is determined, and skip AdSense for Russia
        if (country === null) return;
        if (isRussia) return;

        const idleCallback = window.requestIdleCallback || function (fn) { return setTimeout(fn, 250); };
        const cancelIdle = window.cancelIdleCallback || clearTimeout;

        const taskId = idleCallback(() => {
            if (adVisible) {
                loadAdScripts();
            }
        });

        const fallbackTimer = setTimeout(() => {
            if (adVisible) {
                loadAdScripts();
            }
        }, 2500);

        return () => {
            cancelIdle(taskId);
            clearTimeout(fallbackTimer);
        };
    }, [adVisible, country, isRussia, loadAdScripts]);


    useEffect(() => {
        const node = adWrapperRef.current;
        if (!node) return;

        if (typeof IntersectionObserver === 'undefined') {
            setAdVisible(true);
            return;
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setAdVisible(true);
                    observer.disconnect();
                }
            });
        }, { threshold: 0.1, rootMargin: '200px' });

        observer.observe(node);

        return () => {
            if (observer && node) {
                observer.unobserve(node);
            }
            observer.disconnect();
        };
    }, []);

    return (
        <React.Fragment>
            <Helmet>
                <html lang={currentLang} />
                <meta property="og:locale" content={LOCALE_MAP[currentLang] || 'en_US'} />
            </Helmet>
            <div>
                <Header currentLang={currentLang} location={props.location} />
                {isRussia && <RussianSideRails />}
                {isRussia && <RussianSocialBar />}
                <div className="container mt-main" style={{ minHeight: 'calc(100vh - 7.5rem)' }}>
                    <div ref={adWrapperRef} className={`ad-container-top ${isRussia ? 'ad-container-top-ru' : ''}`}>
                        {isRussia ? (
                            adVisible ? <RussianAdBanner /> : <div className="ad-element-top-placeholder" aria-hidden="true" />
                        ) : adsReady && adVisible ? (
                            <AdSense.Google
                                client='ca-pub-2605486701851317'
                                slot='4112021007'
                                style={{ display: 'block', width: '100%' }}
                                format='auto'
                                responsive='true'
                                layoutKey='-gw-1+2a-9x+5c'
                            />
                        ) : (
                            <div className="ad-element-top-placeholder" aria-hidden="true" />
                        )}
                    </div>
                    {/* <ShowBanner /> */}
                    <Routes {...props} />
                </div>
                <Footer currentLang={currentLang} location={props.location} />
            </div>
        </React.Fragment>
    )
}

export default withRouter(injectIntl(App))